<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="70rem" title="检治标准编码" @close="cancel">
    <el-form :inline="true" :model="staff" :rules="comRules" ref="editor" label-width="5rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input type="text" placeholder="请输入名称" v-model.trim="staff.name" auto-complete="new-account" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input type="text" placeholder="请输入编码" v-model.trim="staff.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="规格" prop="code">
            <el-input type="text" placeholder="请输入规格" v-model.trim="staff.standard"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单位" prop="unit">
            <hic-dict-selector dict-type="Unit" v-model="staff.unit"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="单价" prop="price">
            <el-input type="text" placeholder="请输入单价" v-model="staff.price" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="助记符" prop="shortCode">
            <el-input type="text" placeholder="请输入助记符" v-model="staff.shortCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医保编码" prop="insuranceCode">
            <el-input type="text" placeholder="请输入医保编码" v-model="staff.insuranceCode" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="编码类型" prop="type">
            <hic-dict-selector dict-type="examineStandardType" is-enum v-model="staff.type"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="附加类别" prop="additionType">
            <hic-dict-selector dict-type="AdditionType"  v-model="staff.additionType"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="费用类别" prop="feeType">
            <hic-dict-selector dict-type="FeeType"  v-model="staff.feeType"/>
            <!-- <hic-dict-selector v-model="staff.feeType" dict-type="FeeType" /> -->
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="结算类别" prop="settleType">
            <hic-dict-selector dict-type="SettleType"  v-model="staff.settleType"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="病案类别" prop="recordType">
            <hic-dict-selector dict-type="RecordType"  v-model="staff.recordType"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="统计类别" prop="statisticType">
            <hic-dict-selector dict-type="StatisticType"  v-model="staff.statisticType"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="设备类型" prop="equipmentType">
            <hic-dict-selector dict-type="EquipmentType"  v-model="staff.equipmentType"/>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="备注" prop="memo">
            <el-input type="text" placeholder="请输入备注" v-model="staff.memo" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="医保备注" prop="insuranceMemo">
            <el-input type="text" placeholder="请输入医保备注" v-model="staff.insuranceMemo" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="说明" prop="desc">
            <el-input type="text" placeholder="请输入说明" v-model="staff.desc" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="除外" prop="exception">
            <el-input type="text" placeholder="请输入" v-model="staff.exception" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="国标编码" prop="gbCode">
            <el-input type="text" placeholder="请输入国标编码" v-model="staff.gbCode" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="是否打印" prop="ifPrint">
            <el-switch v-model="staff.ifPrint"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="停用标志" prop="disabled">
            <el-switch v-model="staff.disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="门诊使用" prop="forOp">
            <el-switch v-model="staff.forOp"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="住院使用" prop="forIp">
            <el-switch v-model="staff.forIp"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="医技使用" prop="forMl">
            <el-switch v-model="staff.forMl"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  props: {
    visible: Boolean,
    staff: Object,
  },
  data() {
    var validateCode = (rule, value, callback) => {
      if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
        return callback(new Error('登录名只能包含：【大小写字母】【数字】【_】【-】'));
      }
      return callback();
    };
    var validateTelephone = (rule, value, callback) => {
      if (value && !/^[0-9]*$/.test(value)) {
        return callback(new Error('电话只能包含：【数字】'));
      }
      return callback();
    };
    return {
      comRules: {
        code: [
          {
            required: true,
            message: '请输入编码',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请选名称',
            trigger: 'blur',
          },
        ],
        standard: [
          {
            required: true,
            message: '请输入规格',
            trigger: 'blur',
          },
        ],
        unit: [
          {
            required: true,
            message: '请输入单位',
            trigger: 'blur',
          },
        ],

        price: [
          {
            required: true,
            message: '请输入单价',
            trigger: 'blur',
          },
        ],

        shortCode: [
          {
            required: true,
            message: '请输入助记符',
            trigger: 'blur',
          },
        ],

        insuranceCode: [
          {
            required: true,
            message: '请输入医保编码',
            trigger: 'blur',
          },
        ],

        type: [
          {
            required: true,
            message: '请选择编码类型',
            trigger: 'change',
          },
        ],

        feeType: [
          {
            required: true,
            message: '请选择费用类别',
            trigger: 'change',
          },
        ],

        settleType: [
          {
            required: true,
            message: '请选择结算类别',
            trigger: 'change',
          },
        ],

        recordType: [
          {
            required: true,
            message: '请选择病案类别',
            trigger: 'change',
          },
        ],

        statisticType: [
          {
            required: true,
            message: '请选择统计类别',
            trigger: 'change',
          },
        ],
      },
      disabledSave: false,
      synDisabledSave: false,
      deptFilterKey: null,
    };
  },
  computed: {
    ...mapGetters(['dict', 'user', 'dictEnum']),
    drugRestrict() {
      return this.dict.DrugRestrict.filter(f => f.code !== 'pt');
    },
    depts() {
      let items = [];
      items.push(...this.dict.Dept.filter(d => !this.deptFilterKey || d.text.indexOf(this.deptFilterKey) > -1 || d.code.indexOf(this.deptFilterKey) > -1 || (d.shortCode && d.short.indexOf(this.deptFilterKey) > -1)));
      items.sort((a, b) => {
        return `${a.codeChain}${a.code}` > `${b.codeChain}${b.code}`;
      });
      return items;
    },
  },
  created() {
    this.open();
  },
  methods: {
    open() {
      if (this.staff && this.staff.id) {
        this.queryOidc(this.staff.id);
        try {
          this.$set(this.staff, 'deptCodesSelected', JSON.parse(this.staff.deptCodes));
        } catch (error) {
          this.$set(this.staff, 'deptCodesSelected', []);
        }
        if (this.staff.drugRestrict) {
          this.$set(
            this.staff,
            'drugRestrictSelected',
            JSON.parse(this.staff.drugRestrict).map(m => m.code)
          );
        } else {
          this.$set(this.staff, 'drugRestrictSelected', []);
        }
      }
    },
    queryOidc(staffId) {
      api.Standard.queryOidc(staffId).then(res => {
        if (res.items.length != 0) {
          this.synDisabledSave = true;
        } else {
          this.synDisabledSave = false;
        }
      });
    },
    toSynchronizeInfo() {
      let _this = this;
      _this.loading = true;
      api.Standard.synchronizeInfo(_this.staff.id, 'au')
        .then(res => {
          this.$utils.log(res);
          if (res.status == 0) {
            this.$message({
              message: res.message,
              type: 'success',
            });
          } else if (res.status == 1) {
            this.$message({
              message: res.message,
              type: 'warning',
            });
          } else {
            this.$message.error(res.message);
          }

          // this.$emit("update:visible", false);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    deptFilter(key) {
      this.deptFilterKey = key;
      this.$utils.log(key);
    },
    resetPwd() {
      this.$prompt('员工密码将被设置为系统默认密码，需要输入您的密码验证是当前登录者本人在操作。', '重置密码', {
        inputPlaceholder: '请输入您的密码',
        inputType: 'password',
        inputValidator: value => {
          if (!value) {
            return '密码不能为空';
          }
        },
      })
        .then(({ value }) => {
          api
            .changePwd({
              staffId: this.user.id,
              userPassword: value,
            })
            .then(() => {
              this.$message.success('修改成功！');
            })
            .catch(err => {
              this.$message.error(`修改失败！${err}`);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    save() {
      this.$refs.editor.validate().then(valid => {
        if (valid) {
          this.disabledSave = true;
          api
            .standard.save(this.staff)
            .then(res => {
              this.$message.success('保存成功!');
              this.$emit('ok');
              this.cancel();
            })
            .catch(err => {
              this.$message.error(err);
            })
            .finally(() => {
              this.disabledSave = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: center;
}
</style>
